import React from "react";
import Banner from "./Banner";
import Gallery from "./Gallery";

function Home() {
	return (
		<main>
			<Banner />
			<Gallery />
		</main>
	);
}

export default Home;
